import React from 'react';
import Head from 'expo-router/head';
import { StaticContentScreen } from '@components/common';

// Role-sectioned FAQs per the REDI client plan. Roles with no Phase 1
// functionality still get a stub so users browsing the list see the
// vision. Photo-rights legal language is included verbatim from the
// client's notes on photographing other peoples' property.
const faqSections = [
  {
    title: 'What is REDI?',
    body: 'REDI is a free app that engages the community in preparing for wildfire. Anyone can join as a Fire Scout and start posting observations of progress and opportunities. Insurance carriers can publish checklists, owners can document their preparation, and agents can connect with property owners.',
  },
  {
    title: 'Fire Scout — what to look for',
    body: 'Green observations capture completed wildfire-preparation work: cleared brush, fire-resistant materials, defensible space. Red observations mark opportunities: dry vegetation near structures, combustible storage, blocked evacuation access. Photo proof helps your neighbors prioritize.',
  },
  {
    title: 'Are Fire Scouts anonymous?',
    body: 'Yes. When you join as a Fire Scout without signing up, your posts show as “Fire Scout” and are not tied to your name. You can save your account at any time to keep your posts and add a profile, and you can still choose to post anonymously after signing up.',
  },
  {
    title: 'Property Owner — how this works',
    body: 'Claim your structure on the map. Pick the checklist that matches your carrier (California FAIR Plan, default REDI baseline, or your insurer’s custom list). Complete items, attach photos, and decide who can see each post: public, insurance-only, or private.',
  },
  {
    title: 'Insurance Agent — getting started',
    body: 'Sign up as an Agent, enter your carrier name, and you’ll receive an invite code to share with insured. Owners who use your code link their property to you and pre-select your checklist when they claim a structure.',
  },
  {
    title: 'Insurance Company — coming soon',
    body: 'Carrier-sponsored checklists, agent rollups, and risk dashboards are on the Phase 2 roadmap. Reach out to schedule a call.',
  },
  {
    title: 'Contractor, Evaluator, Fire Official, Community Leader, Educator',
    body: 'Premium capabilities for these roles ship in Phase 2. For now, picking a role at signup lets us notify you when the corresponding features launch.',
  },
  {
    title: 'What can I post photos of?',
    body: 'Yes, you can generally take photos of other homes, provided you are standing on public property (like a street or sidewalk) and shooting what is visible to the naked eye.\n\n— Public spaces: There is no expectation of privacy for the exterior of a home visible from a public area. You generally do not need the homeowner’s permission.\n— Avoid intrusive lenses: Do not use telephoto lenses or drones to peer directly into private windows, as this is an invasion of privacy.\n— Trespassing: Do not step onto private property, driveways, or lawns without the owner’s consent.\n— Commercial use: If you plan to use the photos for commercial purposes (advertising or selling the images), you may need a property release from the owner.',
  },
  {
    title: 'Insurance discounts',
    body: 'Some carriers offer premium discounts for documented mitigation work. Discounts vary by carrier, state, and policy. Check with your agent before assuming a discount; REDI does not guarantee insurance outcomes.',
  },
  {
    title: 'Privacy & visibility',
    body: 'You control who sees the posts about your property. Choose "Public" for community-wide visibility, "Insurance only" for agents and carriers you share with, or "Private" if you’re just keeping personal records. Locations on posts are always shown — hiding the location is disabled to keep observations actionable.',
  },
];

export default function FAQScreen() {
  return (
    <>
      <Head>
        <title>FAQs - Redi</title>
      </Head>
      <StaticContentScreen
        title="Frequently Asked Questions"
        sections={faqSections}
        footerText="Have a question we didn't cover? Email support@weareredi.net."
      />
    </>
  );
}
